<template>
  <div class="card_offer">
    <img
      class="card_offer__image"
      :src="getImageServer() + item.attributes.url"
    >
    <div class="card_offer__actions">
      <v-layout row wrap fill-height>
        <v-flex xs8>
          <div class="actions_date">
            <img src="@/assets/img/icons/available-icon.svg" />
            <div class="actions_date__text">
              <div>Publicado</div>
              <div class="actions_date__date">
                {{ shortDate(item.attributes.created_at) }}
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 class="actions_buttons">
            <button
              class="actions_buttons__delete"
              @click="onDelete"
              @mouseover="hover.delete = true"
              @mouseleave="hover.delete = false"
              :style="{backgroundColor: hover.delete ? '#FC243B' : '#DFE4ED'}"
            >
              <delete-icon
                :color="hover.delete ? '#FFFFFF' : '#5a6b8e'"
                width="35"
                height="35"
              ></delete-icon>
            </button>
            <button
              class="actions_buttons__edit"
              @click="$router.push({name: 'edit_news', params: {news_id: item.id}})"
              @mouseover="hover.edit = true"
              @mouseleave="hover.edit = false"
              :style="{backgroundColor: hover.edit ? '#1476FB' : '#DFE4ED'}"
            >
              <edit-icon
                :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
                width="35"
                height="35"
              ></edit-icon>
            </button>
            <div class="actions_small_desktop">
              <v-menu bottom left >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    style="margin-right: -8px"
                  >
                    <v-icon color="#5a6b8e">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile
                   @click="$router.push({name: 'edit_news', params: {news_id: item.id}})"
                  >
                    <edit-icon
                      :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
                      width="35"
                      height="35"
                    ></edit-icon>
                    <v-list-tile-title class="ml-2" style="color: #5a6b8e"> Editar</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                  >
                    <delete-icon
                      :color="hover.delete ? '#FFFFFF' : '#5a6b8e'"
                      width="35"
                      height="35"
                    ></delete-icon>
                    <v-list-tile-title class="ml-2" style="color: #5a6b8e">Eliminar</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{item.attributes.name | capitalize}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <div
        class="card_offer__body--text"
        v-html="item.attributes.description"
        style="height: 90px"
      ></div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object
  },
  data(){
    return {
      hover: {
        edit: false,
        delete: false
      }
    }
  },
  methods:{
    onDelete(event){
      this.$emit('activate', true);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/NewItem.vue